import React from 'react';
import './Contact.css';

const contactCards = [
  {
    eyebrow: 'Mailing address',
    title: 'University of Rochester',
    body: '500 Joseph C. Wilson Blvd.\nCMC Box 271233\nRochester, NY 14627-1233',
  },
  {
    eyebrow: 'Email',
    title: 'staff@projectlevelthefield.com',
    link: 'mailto:staff@projectlevelthefield.com',
    body: 'We respond within 48 hours.',
  },
  {
    eyebrow: 'Phone',
    title: '(908) 842-4657',
    link: 'tel:+19088424657',
    body: 'Text or call for chapter inquiries.',
  },
];

const Contact = () => (
  <div className="contact-shell">
    <section className="contact-hero">
      <p>Let’s build pathways together</p>
      <h1>Introduce yourself—our national team will route your note within a day.</h1>
      <p className="contact-hero__body">
        Whether you’re launching a chapter, referring students, or interested in supporting our mentors, this
        inbox is monitored seven days a week.
      </p>
    </section>

    <section className="contact-grid">
      <form
        className="contact-form"
        action="https://formsubmit.co/staff@projectlevelthefield.com"
        method="POST"
      >
        <input type="hidden" name="_subject" value="New message from Project LTF" />
        <input type="hidden" name="_captcha" value="false" />
        <div className="contact-form__row">
          <label>
            Full name*
            <input type="text" name="name" placeholder="Jane Doe" required />
          </label>
          <label>
            Email*
            <input type="email" name="email" placeholder="jane@example.com" required />
          </label>
        </div>
        <div className="contact-form__row">
          <label>
            I am a...*
            <select name="role" required>
              <option value="">Select one</option>
              <option value="Parent">Parent/Guardian</option>
              <option value="Student">Student</option>
              <option value="Educator">Educator/Counselor</option>
              <option value="Partner">Potential partner</option>
              <option value="Other">Other</option>
            </select>
          </label>
          <label>
            Location*
            <input type="text" name="location" placeholder="City, State" required />
          </label>
        </div>
        <label>
          Your message*
          <textarea rows="5" name="message" placeholder="How can we help?" required />
        </label>
        <button type="submit">Send message</button>
      </form>

      <div className="contact-sidebar">
        <div className="contact-sidebar__cards">
          {contactCards.map((card) => (
            <article key={card.title}>
              <span>{card.eyebrow}</span>
              {card.link ? (
                <a href={card.link}>{card.title}</a>
              ) : (
                <h3>{card.title}</h3>
              )}
              <p>{card.body}</p>
            </article>
          ))}
        </div>
        <div className="contact-social">
          <h2>Follow the work</h2>
          <div className="contact-social__links">
            <a href="https://www.instagram.com/levelthefieldnationals/" target="_blank" rel="noreferrer">
              Instagram →
            </a>
            <a href="https://www.linkedin.com/company/project-level-the-field/" target="_blank" rel="noreferrer">
              LinkedIn →
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
);

export default Contact;
